// Conversions between the dollars a host types into a currency-masked input and
// the integer cents every money column on the API speaks.

// Accepts what the `currencyMask` input emits ("$1,200.00") as well as a raw
// number or a half-typed string ("1200", "1200.5").
//
// Returns null for anything that isn't a positive amount — blank, junk, or zero
// — which is how the API reads "this reservation has no price".
export function dollarsToCents(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const dollars = Number(String(value).replace(/[^0-9.]/g, ''));
  if (!Number.isFinite(dollars) || dollars <= 0) {
    return null;
  }
  return Math.round(dollars * 100);
}

// The value to seed a currencyMask input with, so an edit starts from what is
// already stored. Null when there is nothing to edit.
export function centsToDollarsInput(cents: number | null | undefined): string | null {
  if (cents === null || cents === undefined) {
    return null;
  }
  return (cents / 100).toFixed(2);
}

// Display formatting for a cents amount, e.g. 120000 -> "$1,200.00".
export function formatCents(cents: number | null | undefined, currency?: string | null): string | null {
  if (cents === null || cents === undefined) {
    return null;
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: (currency || 'USD').toUpperCase(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);
}
